import { Component } from '@angular/core';

@Component({
  selector: 'mprd-available-options-skeleton',
  templateUrl: './available-options-skeleton.component.html',
  styleUrls: ['./available-options-skeleton.component.css'],
})
export class AvailableOptionsSkeletonComponent {
  constructor() {}
}
